export enum TipoFormularioEndereco {
    "GOOGLE_AUTOCOMPLETE" = "GOOGLE_AUTOCOMPLETE",
    "PADRAO" = "PADRAO"
}

